import { render, staticRenderFns } from "./batch-add-lab-order.vue?vue&type=template&id=70076373"
import script from "./batch-add-lab-order.vue?vue&type=script&lang=js"
export * from "./batch-add-lab-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports